export default __webpack_public_path__ + "static/media/roy_robins.c49ae651.jpg";